<template>
  <div class="container">
    <div class="left">
      <!-- <div class="title">常用操作</div> -->
      <div class="item-box">
        <div class="item" v-for="item in list" @click="gotoPath(item.path)">
          <img class="imga" :src="require(`@/assets/images/${sxtitlea(item)}.jpg`)"  />
          <!-- <img class="imga" :src="require(`@/assets/images/${item.meta.titleEn}.jpg`)"  /> -->
          <!-- <div>{{ inle == 'zh' ? item.meta.title : item.meta.titleEn }}</div> -->
          <div>{{ sxtitle(item) }}</div>
          
        </div>
      </div>
    </div>
    <div class="right">
      <div class="avatar-box">
        <div style="display: flex;align-items: center;">
          <el-avatar class="climig"> {{ userimg(name) }} </el-avatar>
          <div class="user-info">
            <div class="nname">{{ name }}</div>
            <div>{{ role }}</div>
          </div>
        </div>

        <div class="tit-box">
          <div class="tit">{{ $t('menu.Distributor') }}:</div>
          <div class="val">{{ jxs }}</div>
        </div>

        <div class="tit-box">
          <div class="tit">{{ $t('menu.AfterSalesAccountCurrency') }}:</div>

          <div class="val">{{ shbz }}</div>
        </div>


      </div>
      <div class="tttt">
        <div class="title">{{ $t('menu.Onlyunread') }}（<i style="    font-style: normal;">{{ noticeTotal }}</i>）</div>
        <div class="notice-box">
          <div class="notice-item" v-for="item in noticeList" @click="gotoNotice">
            <div class="name">{{ item.noticeTitle }}</div>
            <div class="time">{{ formatTime(item.createTime) }}</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { noticetList, getInfo,listAccType } from '@/api/api.js'
export default {
  name: 'start',
  data () {
    return {
      name: '',
      list: [],
      formInline: {
        title: "",
        status: 0,
        startTime: "",
        endTime: "",
        contact: "",
        category: "",
        type: "",
      },
      currentPage3: 1,
      noticeList: [],
      noticeTotal: 0,
      inle: 'zh',
      role: '',
      jxs: '',
      shbz: '',
      acclist:''
    }
  },
  methods: {
      sxtitle(e){
      let a =''
      if(this.inle=='zh'){
        a=e.meta.title
      }
    if(this.inle=='en'){
      if(e.meta.titleEn.indexOf(":") !== -1){
        let c =JSON.parse(e.meta.titleEn)
     
        a=c.en
      }else{
        a=e.meta.titleEn
      }
      

      }
      if(this.inle=='de'){
         if(e.meta.titleEn.indexOf(":") !== -1){
             let d =JSON.parse(e.meta.titleEn)
a=d.de
         } else{
        a=e.meta.titleEn
      } 
         
      
      }
      return a

    },
      sxtitlea(e){
      let a =''
     
   
      if(e.meta.titleEn.indexOf(":") !== -1){
        let c =JSON.parse(e.meta.titleEn)
     
        a=c.en
      }else{
        a=e.meta.titleEn
      }
      

     
      return a

    },
    async acc () {
      let param = new URLSearchParams();
      const { data: res } = await listAccType(param)
    this.acclist  = res.data
   

    },
    async infoaa () {
      let param = new URLSearchParams();
      const { data: res } = await getInfo(param)
    
 sessionStorage.setItem("platform",res.user.platform)//0:运营平台 , 1:经销商平台 , 2:零售商平台
      this.acclist.forEach(e => {
        if (e.id == res.user.dealers[0].accTypeIdLs&&res.uesr.platform=='2') {
          console.log(e.id ,res.user.dealers[0].accTypeIdLs);
          
          sessionStorage.setItem("shbz", e.currencyType)
   

          // console.log(123123, res.user.dealers[0].accTypeIdSh, e.id, e.currencyType);
        }
         if (e.id == res.user.dealers[0].accTypeIdSh&&res.uesr.platform!=='2') {
          
          sessionStorage.setItem("shbz", e.currencyType)
   

          // console.log(123123, res.user.dealers[0].accTypeIdSh, e.id, e.currencyType);
        }
      })
    


    },
    formatTime (str) {
      return str.slice(0, 10)
    },
    userimg (str) {
      return str.slice(0, 1)
    },
    gotoPath (path) {
      this.$router.push(path)
    },
    gotoNotice () {
      this.$router.push('/public')
    },
    async getNoticeList () {
      let param = new URLSearchParams();
      let category = this.formInline.category;
      let type = this.formInline.type;
      let startTime = this.formInline.startTime;
      let endTime = this.formInline.endTime;
      let status = this.formInline.status;
      let searchValue = this.formInline.title;
      const { data: res } = await noticetList(
        param,
        status,
        searchValue,
        '',
        this.currentPage3,
        100,
        'desc',
        'id',
      );
      console.log('res', res)
      this.noticeList = res.rows
      let num = 0
      res.summary.forEach(zz => {
        num = num + zz.sum
      })

      this.noticeTotal = num
      sessionStorage.setItem('noticeTotal', num)
    },
    async info () {
      let param = new URLSearchParams();
      const { data: res } = await getInfo(param)
      this.role = res.user.roles[0].roleName
      this.jxs = res.user.dealers[0].dealerNameFull
    },
    formatMenu (arr) {
      let list = []
      arr.forEach(a => {
        if (a.children) {
          a.children.forEach(child => {
            if (child.meta.remark == '常用') {
              list.push(child)
            }
          })
        } else {
          if (a.meta.remark == '常用') {
            list.push(a)
          }
        }
      })
      return list
    },
  },
  created () {
    let arr = JSON.parse(sessionStorage.getItem('menu'))
    this.inle = sessionStorage.getItem('i18n')
    this.list = this.formatMenu(arr)
    console.log(this.list)
    this.info()
    this.getNoticeList()
    this.acc()
    this.infoaa()
    this.name = sessionStorage.getItem('userName')
    this.shbz = sessionStorage.getItem('shbz')

  },
  mounted () {
  },
}
</script>
<style scoped lang="less">
.container {
  display: flex;
  height: 800px;

  .left {
    flex: 7;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  }

  .right {
    display: flex;
    flex-direction: column;
    margin-left: 20px;
    flex: 3;
  }
}

.tttt {
  flex: 1;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  overflow-y: auto;
  margin-top: 30px;

  .title {
    height: 40px;
    padding-left: 10px;
    font-size: 16px;
    display: flex;
    font-weight: 600;
    align-items: center;
    border-bottom: 1px solid #d7d7d7;

    i {
      color: #d9001b;
      display: flex;
      align-items: center;
      padding-top: 5px;
    }
  }
}


.imga {
  width: 80px;
  height: 80px;
  // border: 1px solid #ccc;

  margin-bottom: 2px;
}

.item-box {
  display: flex;

  .item {
    height: 70px;
    width: 160px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-right: 10px;
    padding-top: 80px;
  }
}
.climig{
  font-size: 30px;
  font-weight: 600;
  background-color: #159bd5 !important;
}
.notice-box {
  padding: 20px;

  .notice-item {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    margin-top: 8px;
    .name {
      font-size: 14px;
    }

    .time {
      font-size: 14px;
      color: #aaaaaa;
    }
  }
}

.avatar-box {
  height: 200px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

  .user-info {
    margin-left: 20px;

    .nname {
      font-weight: 550;
      font-size: 18px;
    }
  }
}

.tit-box {
  display: flex;

  .tit {
    color: #8a8a8a;
  }

  .vval {
    color: #333333;
  }
}
</style>
